<div class="modal-content">

  <div class="text-484b59 p-4 f-20" style="background-color: #f6f6f6;">
    <div class="d-flex justify-content-between align-items-center">
      <span class="f-18 font-weight-500"><span *ngIf="totalTarget > 1">{{responseLength}} </span>Candidate added to Email Campaign <span><i class="fa-solid fa-badge-check ml-1"
            style="color: #12bf08;"></i>
        </span>
      </span>
      <span class="pointer f-12" (click)="dismiss()" *ngIf="!type"><i class="fa-solid fa-xmark"></i></span>
    </div>
  </div>
  <div class="d-flex flex-column w-100 mt-2 px-3" *ngIf="!type">

    <p>We couldn’t find a valid email from our contact partners.
      However, you can manually add the candidate’s email anytime.</p>
  </div>
    <div class="d-flex flex-column w-100 mt-2 px-3" *ngIf="type == 'Bulk'">

    <p>Please continue shortlisting while we search for missing contacts.
 You’ll be notified by email once updates are available.
 You can also view the campaign listing right away if needed.</p>
  </div>

  <div class="row mt-2 px-3 py-2" *ngIf="!type">
    <div class="col text-right">
      <button data-testid="auto-app-bulk-email-campaign-button-1" class="btn-trms-white mr-3" (click)="dismiss()">
        I'll add later
      </button>
      <button data-testid="auto-app-bulk-email-campaign-button-2" class="btn-trms-small" (click)="redirectToEmailCampaign()">Add Email</button>
    </div>
  </div>

    <div class="row mt-2 px-3 py-2" *ngIf="type == 'Bulk'">
    <div class="col text-right">
      <button data-testid="auto-app-bulk-email-campaign-button-3" class="btn-trms-white mr-3" (click)="dismissLater()">
        View later
      </button>
      <button data-testid="auto-app-bulk-email-campaign-button-4" class="btn-trms-small" (click)="redirectToEmailCampaign()">View Email Campaign</button>
    </div>
  </div>
</div>
